/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getWatchStatusBatchV1RequestSchema = z.object({
  collectionIds: z.array(z.number().int()).max(500),
});

export type IGetWatchStatusBatchV1Request = z.infer<typeof getWatchStatusBatchV1RequestSchema>;
